// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizedLayout_content__3Sn46"};